import AdminLayout from "../../../components/admin/layout/AdminLayout";
import CreateManager from "../../../components/admin/manager/CreateManger";
import { useLocation } from "react-router-dom";

function EditManagerPage() {
  const location = useLocation();
  const editData = location.state || {};

  return (
    <AdminLayout>
      <CreateManager editData={editData} />
    </AdminLayout>
  );
}

export default EditManagerPage;
